import { Link } from "react-router-dom";
import { ArrowRight, HelpCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_ITEMS } from "@/data/siteData";

export default function FAQ() {
  return (
    <div className="grid-bg min-h-screen">
      {/* Header */}
      <div
        className="py-20"
        style={{ background: 'var(--bg-surface)', borderBottom: '1px solid rgba(0,240,255,0.08)' }}
      >
        <div className="max-w-7xl mx-auto px-6">
          <span
            className="text-[11px] tracking-[0.2em] uppercase block mb-2"
            style={{ color: 'var(--neon-magenta)', fontFamily: "'Roboto Mono', monospace" }}
          >
            Support
          </span>
          <h1
            className="text-4xl sm:text-5xl font-bold tracking-tighter mb-4"
            style={{ fontFamily: "'Rajdhani', sans-serif" }}
          >
            Frequently Asked Questions
          </h1>
          <p className="text-sm max-w-2xl" style={{ color: 'var(--text-secondary)' }}>
            Find answers to common questions about our research compounds, ordering process, quality standards, and shipping policies.
          </p>
        </div>
      </div>

      {/* FAQ List */}
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {FAQ_ITEMS.map((faq, i) => (
            <AccordionItem
              key={faq.id}
              value={faq.id}
              data-testid={`faq-item-${i}`}
              className="neon-border rounded-lg overflow-hidden px-6"
              style={{ background: 'var(--bg-surface)', borderBottom: 'none' }}
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-sm font-semibold py-5 hover:no-underline"
                style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: '1rem', color: 'var(--text-primary)' }}
              >
                <div className="flex items-start gap-3">
                  <HelpCircle className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: 'var(--neon-cyan)' }} />
                  <span>{faq.question}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent
                className="text-sm leading-relaxed pb-5 pl-7"
                style={{ color: 'var(--text-secondary)' }}
              >
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* CTA */}
        <div
          className="neon-border rounded-lg p-10 text-center mt-16"
          style={{ background: 'var(--bg-surface)' }}
        >
          <h2
            className="text-xl font-bold mb-3"
            style={{ fontFamily: "'Rajdhani', sans-serif" }}
          >
            Still Have Questions?
          </h2>
          <p className="text-sm mb-6" style={{ color: 'var(--text-secondary)' }}>
            Our team is ready to help with any additional questions about our research compounds or ordering process.
          </p>
          <Link
            to="/contact"
            data-testid="faq-contact-btn"
            className="btn-neon px-8 py-3 rounded text-sm inline-flex items-center gap-2"
          >
            CONTACT US <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
